"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImagePreview = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("@lingui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _styledComponents = _interopRequireDefault(require("styled-components"));

/* eslint-disable @typescript-eslint/no-invalid-void-type */
const Container = _styledComponents.default.div`
  max-width: 120px;
  text-align: right;
  margin-bottom: ${_blocks.spacing.default};
`;
const Button = _styledComponents.default.button`
  color: ${_blocks.palette.red5};
`;
const ImageContainer = _styledComponents.default.a.attrs({
  target: '_blank'
})`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border: 1px solid ${_blocks.palette.neutral5};
  border-radius: ${_blocks.borderRadius.default};
`;
const Img = _styledComponents.default.img`
  object-fit: cover;
  /* Fallbacks - does not affect behaviour of object-fit */
  max-width: 100%;
  max-height: 100%;
`;

class ImagePreview extends _react2.Component {
  constructor(props) {
    super(props);
    (0, _defineProperty2.default)(this, "preview", void 0);
    (0, _defineProperty2.default)(this, "setIsNonImage", () => {
      // If the attachment src doesn't resolve to an image, assume it's a different file type
      this.setState({
        nonImageAttachment: true
      });
    });
    (0, _defineProperty2.default)(this, "handleRemove", () => {
      if (window.confirm(_core.i18n._({
        id: 'action_form.confirm_remove_attachment',
        message: `You are about to remove the attachment from this action, continue?`
      }))) {
        var _this$props$onRemove, _this$props;

        (_this$props$onRemove = (_this$props = this.props).onRemove) === null || _this$props$onRemove === void 0 ? void 0 : _this$props$onRemove.call(_this$props);
      }
    });
    this.state = {
      nonImageAttachment: false
    };
    this.preview = /*#__PURE__*/_react2.default.createRef();
  }

  render() {
    const {
      src,
      alt
    } = this.props;
    return /*#__PURE__*/_react2.default.createElement(Container, null, /*#__PURE__*/_react2.default.createElement(ImageContainer, {
      href: src,
      onClick: e => e.stopPropagation()
    }, this.state.nonImageAttachment ? /*#__PURE__*/_react2.default.createElement(_blocks.AnalyticsTrends, null) : /*#__PURE__*/_react2.default.createElement(Img, {
      ref: this.preview,
      onError: this.setIsNonImage,
      src: src,
      alt: alt
    })), this.props.onRemove !== undefined && /*#__PURE__*/_react2.default.createElement(Button, {
      onClick: this.handleRemove
    }, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
      id: "action_form.remove"
    })));
  }

}

exports.ImagePreview = ImagePreview;
(0, _defineProperty2.default)(ImagePreview, "defaultProps", {
  onRemove: null,
  alt: 'Image preview'
});